/* Dependencies */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

/* Stores */

var _storesLanguage = require('stores/language');

var _storesLanguage2 = _interopRequireDefault(_storesLanguage);

/* Components */

var _componentsUiModal = require('components/ui/modal');

var _componentsUiModal2 = _interopRequireDefault(_componentsUiModal);

var _componentsUiButtonGroup = require('components/ui/button-group');

var _componentsUiButtonGroup2 = _interopRequireDefault(_componentsUiButtonGroup);

var _componentsUiButton = require('components/ui/button');

var _componentsUiButton2 = _interopRequireDefault(_componentsUiButton);

var _componentsUiTextArea = require('components/ui/text-area');

var _componentsUiTextArea2 = _interopRequireDefault(_componentsUiTextArea);

var _componentsUiIcon = require('components/ui/icon');

var _componentsUiIcon2 = _interopRequireDefault(_componentsUiIcon);

var _componentsProjectTranslationHelper = require('components/project/translation-helper');

var _componentsProjectTranslationHelper2 = _interopRequireDefault(_componentsProjectTranslationHelper);

exports['default'] = _react2['default'].createClass({
  displayName: 'editor',

  getInitialState: function getInitialState() {
    return {
      items: this._flattenObject(this.props.item),
      removals: {},
      selectedItem: {},
      showHelper: false
    };
  },

  render: function render() {
    var _this = this;

    var _state = this.state;
    var items = _state.items;
    var removals = _state.removals;
    var selectedItem = _state.selectedItem;
    var showHelper = _state.showHelper;

    var itemKeys = [];

    var itemProps = Object.keys(items).map(function (key) {
      var keyValue = items[key];
      var locked = false;
      var removable = true;
      var className = 'item-component';

      // Lock the following keys.
      if (key === 'id' || key === 'password.iterations' || key === 'password.salt' || key === 'password.data') {
        locked = true;
        removable = false;
      }

      // Lock the __object__ keys,
      // but retain removability.
      if (keyValue === '__object__') {
        keyValue = '';
        locked = true;
      }

      // Convert boolean values to strings.
      if (typeof keyValue === 'boolean') {
        keyValue = keyValue.toString();
      }

      // Add special class to locked keys.
      if (locked) {
        className += ' locked';
      }

      // Add special class to selected keys.
      if (selectedItem.key === key) {
        className += ' selected';
      }

      var itemKey = _react2['default'].createElement(
        'div',
        {
          key: key,
          className: className,
          onClick: !locked && _this._onItemClick.bind(null, key, keyValue) },
        _react2['default'].createElement(
          'div',
          { className: 'subtitle' },
          key
        ),
        _react2['default'].createElement(
          'div',
          { className: 'title' },
          keyValue
        ),
        removable && _react2['default'].createElement(
          'div',
          { className: 'actions' },
          _react2['default'].createElement(
            'div',
            { className: 'delete', onClick: _this._onDeleteProperty.bind(_this, key) },
            _react2['default'].createElement(_componentsUiIcon2['default'], { name: 'trash-o' })
          )
        )
      );

      itemKeys.push(itemKey);
    });

    var helper = null;
    if (showHelper) {
      helper = _react2['default'].createElement(_componentsProjectTranslationHelper2['default'], {
        component: _react2['default'].createElement(
          'div',
          null,
          'The most common scenario will be to add simple properties with simple values.',
          _react2['default'].createElement('br', null),
          'However, it is also possible to add deeply nested objects and arrays.',
          _react2['default'].createElement('br', null),
          _react2['default'].createElement('br', null),
          _react2['default'].createElement(
            'strong',
            null,
            'Adding Objects:'
          ),
          _react2['default'].createElement('br', null),
          _react2['default'].createElement(
            'em',
            null,
            'objectName.propertyName',
            _react2['default'].createElement('br', null),
            'objectName.propertyName.deeperPropertyName'
          ),
          _react2['default'].createElement('br', null),
          _react2['default'].createElement('br', null),
          _react2['default'].createElement(
            'strong',
            null,
            'Adding Arrays:'
          ),
          _react2['default'].createElement('br', null),
          _react2['default'].createElement(
            'em',
            null,
            'objectName[0]',
            _react2['default'].createElement('br', null),
            'objectName[1]',
            _react2['default'].createElement('br', null),
            'objectName.propertyName[0]',
            _react2['default'].createElement('br', null),
            'objectName.propertyName[1]'
          )
        ),
        onClick: this._onToggleHelperClick });
    }

    return _react2['default'].createElement(
      'div',
      null,
      _react2['default'].createElement(
        _componentsUiModal2['default'],
        { className: 'translation-editor-component', onCancel: this._onCancel },
        _react2['default'].createElement(
          'div',
          { className: 'sidebar' },
          _react2['default'].createElement(
            'div',
            { className: 'list-component' },
            itemKeys
          ),
          _react2['default'].createElement(
            _componentsUiButtonGroup2['default'],
            null,
            _react2['default'].createElement(
              'div',
              { className: 'add', onClick: this._onAddProperty },
              _react2['default'].createElement(_componentsUiIcon2['default'], { name: 'plus' })
            ),
            _react2['default'].createElement(_componentsUiButton2['default'], { translationKey: 'cancel', className: 'cancel', onClick: this._onCancel }),
            _react2['default'].createElement(_componentsUiButton2['default'], { translationKey: 'save', className: 'submit', onClick: this._onSave.bind(null, items, removals) })
          )
        ),
        _react2['default'].createElement(
          'div',
          { className: 'content' },
          _react2['default'].createElement(
            'div',
            { className: 'editor-wrapper' },
            selectedItem.key && _react2['default'].createElement(_componentsUiTextArea2['default'], {
              ref: 'data',
              value: selectedItem.value,
              placeholder: ' ',
              description: selectedItem.key,
              showDescription: 'always',
              onChange: this._onChange }),
            _react2['default'].createElement('div', {
              className: 'helper-button',
              onClick: this._onToggleHelperClick })
          )
        )
      ),
      { helper: helper }
    );
  },

  _onItemClick: function _onItemClick(key, value) {
    var removals = this.state.removals;

    if (removals[key] !== undefined) {
      return;
    }

    this.setState({
      selectedItem: { key: key, value: value }
    });
  },

  _onToggleHelperClick: function _onToggleHelperClick() {
    this.setState({
      showHelper: !this.state.showHelper
    });
  },

  _onAddProperty: function _onAddProperty() {
    var inputKey = this._sanitizeKey(prompt(_storesLanguage2['default'].translate('content_editor_enter_key'), ''));

    if (inputKey) {
      var items = this.state.items;

      // Rough check to see if the item already exists.
      if (items[inputKey] || this._unflattenObject(items)[inputKey]) {
        alert(_storesLanguage2['default'].translate('content_editor_enter_key_error_overwrite'));

        return;
      }

      items[inputKey] = '';

      this.setState({
        items: items,
        selectedItem: { key: inputKey, value: '' }
      });
    } else {
      alert(_storesLanguage2['default'].translate('content_editor_enter_key_error_empty'));
    }
  },

  _onDeleteProperty: function _onDeleteProperty(key) {
    if (confirm(_storesLanguage2['default'].translate('translation_editor_delete_property_warning'))) {
      var _state2 = this.state;
      var items = _state2.items;
      var removals = _state2.removals;

      // Update the view.
      delete items[key];

      // Add to removals list.
      var flattenedKey = this._flattenKey(key);

      removals[flattenedKey] = '';

      // Also remove children.
      for (var childKey in items) {
        if (childKey.indexOf(key + '.') !== -1 || childKey.indexOf(key + '[') !== -1) {
          delete items[childKey];
        }
      }

      this.setState({
        items: items,
        removals: removals,
        selectedItem: {}
      });
    }
  },

  _onChange: function _onChange(event) {
    var _state3 = this.state;
    var items = _state3.items;
    var selectedItem = _state3.selectedItem;
    var value = this.refs.data.value;

    var key = selectedItem.key;

    items[key] = this._typeFixProperty(value);

    this.setState({
      items: items
    });
  },

  _onCancel: function _onCancel() {
    this.props.onCancel();
  },

  _onSave: function _onSave(items, removals) {
    this.props.onSave(this._unflattenObject(items), removals);
  },

  _flattenObject: function _flattenObject(obj) {
    var result = {};

    for (var item in obj) {
      if (!obj.hasOwnProperty(item)) {
        continue;
      }

      if (typeof obj[item] === 'object') {
        var flatObject = this._flattenObject(obj[item]);

        if (!flatObject.length) {
          result[item] = '__object__';
        }

        for (var expandedItem in flatObject) {
          if (!flatObject.hasOwnProperty(expandedItem)) {
            continue;
          }

          if (!isNaN(expandedItem)) {
            result[item + '[' + expandedItem + ']'] = flatObject[expandedItem];
          } else {
            var key = this._sanitizeArrayKey(item + '.' + expandedItem);

            result['' + key] = flatObject[expandedItem];
          }
        }
      } else {
        result[item] = obj[item];
      }
    }

    return result;
  },

  _unflattenObject: function _unflattenObject(obj) {
    if (Object(obj) !== obj || Array.isArray(obj)) {
      return obj;
    }

    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g;
    var result = {};

    for (var prop in obj) {
      var current = result;
      var currentProp = '';
      var i = undefined;

      while (i = regex.exec(prop)) {
        current = current[currentProp] || (current[currentProp] = i[2] ? [] : {});
        currentProp = i[2] || i[1];
      }

      if (obj[prop] === '__object__') {
        continue;
      }

      current[currentProp] = obj[prop];
    }

    return result[''] || result;
  },

  _typeFixProperty: function _typeFixProperty(prop) {
    if (prop === 'true' || prop === 'false') {
      return prop === 'true' ? true : false;
    }

    if (!isNaN(prop)) {
      return Number(prop);
    }

    return prop;
  },

  _sanitizeKey: function _sanitizeKey(key) {
    // Remove all special characters and spaces,
    // but preserve dots and square brackets.
    return key.replace(/[^A-Z0-9.\[\]]+/ig, '');
  },

  _sanitizeArrayKey: function _sanitizeArrayKey(key) {
    return key.replace(/\.[0-9]/g, '[' + key.replace(/\D/g, '') + ']');
  },

  _flattenKey: function _flattenKey(key) {
    return key.replace('[', '.').replace(']', '');
  }

});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/datasource/editor.js
 **/